module.exports = __webpack_public_path__ + "img/deproef.78e36232.webp";